export default {
    token: localStorage.getItem('token') || null,
    userId: parseInt(localStorage.getItem('userId')) || null,
    userName: localStorage.getItem('userName') || null,
    userEmail: localStorage.getItem('userEmail') || null,
    userFirstName: localStorage.getItem('userFirstName') || null,
    userLastName: localStorage.getItem('userLastName') || null,
    user: null,
    receivedPermissions: JSON.parse(localStorage.getItem('receivedPermissions')) || false,
    permissions: JSON.parse(localStorage.getItem('userPermissions')) || [],
}
